var global = require('../internals/global');
var setGlobal = require('../internals/set-global');

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/shared-store.js